import { Sport } from '__generated__/globalTypes';
import { useConfigContext } from 'contexts/config';
import { useSportContext } from 'contexts/sport';

export default (competitionEligibilityFilter: string | undefined) => {
  const { sport = Sport.FOOTBALL } = useSportContext();
  const {
    so5: {
      footballCompetitionEligibilityAlgoliaFilters,
      baseballCompetitionEligibilityAlgoliaFilters,
      nbaCompetitionEligibilityAlgoliaFilters,
    },
  } = useConfigContext();
  const competitionEligibilityFilterValue = {
    [Sport.FOOTBALL]: footballCompetitionEligibilityAlgoliaFilters,
    [Sport.BASEBALL]: baseballCompetitionEligibilityAlgoliaFilters,
    [Sport.NBA]: nbaCompetitionEligibilityAlgoliaFilters,
  }[sport];

  if (!competitionEligibilityFilter || !competitionEligibilityFilterValue)
    return null;

  return competitionEligibilityFilterValue[competitionEligibilityFilter];
};
